import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'

import { OtoIndividualPlaceInput } from '../../../lib/types/models/journey-place/oto-individual-place-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'
import { OTO_INDIVIDUAL_PLACE_FORM_SCHEMA_VALIDATION } from './utils'

type Props = BaseFormProps<OtoIndividualPlaceInput> & {
  className?: string
}

const OtoIndividualPlaceForm = ({ defaultValues, className, ...validationButtonProps }: Props) => {
  const form = useForm<OtoIndividualPlaceInput>({
    resolver: zodResolver(OTO_INDIVIDUAL_PLACE_FORM_SCHEMA_VALIDATION),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={(e) => {
          e.stopPropagation()
          form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))(e)
        }}
      >
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name={'title'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput required {...field} type={'text'} label={'Intitulé'} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'code'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput required {...field} type={'text'} label={'Code IATA'} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <div className={'flex justify-end pb-4 pr-4'}>
          <ValidationButtons {...validationButtonProps} />
        </div>
      </form>
    </Form>
  )
}

export default OtoIndividualPlaceForm
